import { getClient } from '@sentry/core';
export const MOBILE_FEEDBACK_INTEGRATION_NAME = 'MobileFeedback';
export const feedbackIntegration = (initOptions = {}) => {
    return {
        name: MOBILE_FEEDBACK_INTEGRATION_NAME,
        options: initOptions,
    };
};
export const getFeedbackOptions = () => {
    var _a;
    const integration = (_a = getClient()) === null || _a === void 0 ? void 0 : _a.getIntegrationByName(MOBILE_FEEDBACK_INTEGRATION_NAME);
    if (!integration) {
        return {};
    }
    return integration.options;
};
//# sourceMappingURL=integration.js.map